import React from 'react';
import NavItems from './NavItems';
import { NavLink } from 'react-router-dom';

import './Header.css';

function Header() {

  return (
    <header className="wrapper bg-light">
      <nav className="navbar navbar-expand-lg classic transparent navbar-light">
        <div className="container containerfull d-flex justify-content-between align-items-center">
          <div className="navbar-brand hide-on-mobile">
            <NavLink className="nav-link" to="/?quan76f=1@t.ie">
              <img src="/assets/img/irish-logo.png" alt="Irish Funds Logo" />
            </NavLink>
          </div>
        </div>
        <div className="collapse navbar-collapse" id="navbarNav">
          <NavItems />
        </div>
      </nav>
    </header>
  );
}

export default Header;
